module.exports = __webpack_public_path__ + "img/Number=73.c4dff98d.png";